function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o)
    return; if (typeof o === "string")
    return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor)
    n = o.constructor.name; if (n === "Map" || n === "Set")
    return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length)
    len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) {
    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
    try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
            if (Object(_i) !== _i)
                return;
            _n = !1;
        }
        else
            for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0)
                ;
    }
    catch (err) {
        _d = !0, _e = err;
    }
    finally {
        try {
            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r))
                return;
        }
        finally {
            if (_d)
                throw _e;
        }
    }
    return _arr;
} }
function _arrayWithHoles(arr) { if (Array.isArray(arr))
    return arr; }
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Dialog, DialogButtonsFooter, Flag, Text, ToggleButtonGroup } from '@nordlayer/rivendell-ui';
import EuFlagIcon from 'assets/img/flag-eu.svg';
import { getAvailableRedirectPath } from 'utils/routing/getAvailableRedirectPath';
import { getPathWithRegion } from 'utils/routing/getPathWithRegion';
import { getRedirectPathItemsForRegion, isListPage, isPathAllowedForRegion } from 'utils/routing/regionAvailability';
import { useAccount } from 'api/Account/queries';
import { useRegion } from './RegionProvider';
import { AvailableRegions, REGION_DISPLAY_NAMES } from './constants';
import { EuFlag, OptionLabel } from './styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var RegionSwitcher = function RegionSwitcher() {
    var _useLocation = useLocation(), search = _useLocation.search, pathname = _useLocation.pathname;
    var _useAccount = useAccount(), account = _useAccount.data;
    var _useState = useState(null), _useState2 = _slicedToArray(_useState, 2), pendingRegion = _useState2[0], setPendingRegion = _useState2[1];
    var _useState3 = useState(null), _useState4 = _slicedToArray(_useState3, 2), pendingUrl = _useState4[0], setPendingUrl = _useState4[1];
    var history = useHistory();
    var region = useRegion();
    var selectRegion = function selectRegion(_ref) {
        var _ref2 = _slicedToArray(_ref, 1), selectedRegion = _ref2[0];
        if (selectedRegion && selectedRegion !== region) {
            setPendingRegion(selectedRegion);
        }
    };
    var closeModal = function closeModal() {
        return setPendingRegion(null);
    };
    var changeRegion = function changeRegion() {
        if (!pendingRegion || !account)
            return;
        var fallbackPath = getAvailableRedirectPath(getRedirectPathItemsForRegion(pendingRegion), account.permissions);
        if (isListPage(pathname)) {
            var targetPath = isPathAllowedForRegion(pathname, pendingRegion) ? pathname + search : fallbackPath;
            history.replace(getPathWithRegion(targetPath, pendingRegion));
            closeModal();
            return;
        }
        /**
         * Opened from an effect rather than here, so the dialog has already unmounted first. React
         * Aria keeps focus inside an open modal, and in Firefox that fights the new tab taking focus
         * and locks up the original tab.
         */
        setPendingUrl(getPathWithRegion(fallbackPath, pendingRegion));
        closeModal();
    };
    useEffect(function () {
        if (!pendingUrl)
            return;
        if (!window.open(pendingUrl, '_blank')) {
            window.location.assign(pendingUrl);
        }
        setPendingUrl(null);
    }, [pendingUrl]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [/*#__PURE__*/ _jsx(ToggleButtonGroup, {
                size: "sm",
                selectionMode: "single",
                disallowEmptySelection: true,
                isDisabled: !account,
                selectedKeys: [region],
                onSelectionChange: selectRegion,
                options: [{
                        value: AvailableRegions.US,
                        label: /*#__PURE__*/ _jsxs(OptionLabel, {
                            children: [/*#__PURE__*/ _jsx(Flag, {
                                    countryCode: "US"
                                }), "US DC"]
                        })
                    }, {
                        value: AvailableRegions.EU,
                        label: /*#__PURE__*/ _jsxs(OptionLabel, {
                            children: [/*#__PURE__*/ _jsx(EuFlag, {
                                    src: EuFlagIcon,
                                    alt: "eu-flag-icon"
                                }), "EU DC"]
                        })
                    }],
                "data-testid": "region-switcher"
            }), /*#__PURE__*/ _jsxs(Dialog, {
                isOpen: pendingRegion !== null,
                "aria-label": "Change Data Center",
                title: "Change Data Center",
                mobileMode: "bottom-drawer",
                onPressClose: closeModal,
                children: [/*#__PURE__*/ _jsx(Text, {
                        tag: "p",
                        color: "--riv-color-fg-primary",
                        preset: "--riv-font-body-md-regular",
                        children: pendingRegion && "Are you sure you want to change the [".concat(REGION_DISPLAY_NAMES[region], "] to [").concat(REGION_DISPLAY_NAMES[pendingRegion], "]?")
                    }), /*#__PURE__*/ _jsxs(DialogButtonsFooter, {
                        children: [/*#__PURE__*/ _jsx(Button, {
                                size: "md",
                                variant: "secondary",
                                onPress: closeModal,
                                children: "Cancel"
                            }), /*#__PURE__*/ _jsx(Button, {
                                size: "md",
                                variant: "primary",
                                onPress: changeRegion,
                                children: "Change"
                            })]
                    })]
            })]
    });
};
